import * as actionTypes from "./actionTypes";
import * as types from "./types";


// Event Job List - Time Based Trigger
export const fetchJobListReq = (params: types.IJobListParams): types.FetchJobListReq => ({
    type: actionTypes.FETCH_JOB_LIST_REQUEST,
    params,
});

export const fetchJobListSuccess = (
    payload: types.FetchJobListSuccessPayload
): types.FetchJobListSuccess => ({
    type: actionTypes.FETCH_JOB_LIST_SUCCESS,
    payload,
});

export const fetchJobListFailure = (
    payload: types.FetchJobListFailurePayload
): types.FetchJobListFailure => ({
    type: actionTypes.FETCH_JOB_LIST_FAILURE,
    payload,
});

